import React from 'react';
import { Box } from '@common-fe/common-fe';

import ResendList from './ResendList';

interface Props {
  employeeId: string;
}
const ResendSection: React.FC<Props> = ({ employeeId }) => {
  return (
    <Box data-testid="resend-section" >
      <ResendList employeeId={employeeId} />
    </Box>
  );
};

export default ResendSection;